import { z } from "zod"

export const SubmitPriceChangeSchema = z.object({
  reasonForUpdate: z.string().min(1, { message: "Reason For Update is required." }),
})

export type SubmitPriceChangeSchemaFormValues = z.infer<typeof SubmitPriceChangeSchema>
